import { clients } from '@moovly/clients';
import { MoovlyObject, UnfinishedObject } from '@moovly/clients/lib/resources/objects/objects.interfaces';

export const pollObject = async (obj: UnfinishedObject | MoovlyObject): Promise<MoovlyObject> => {
  if (obj.status === 'finished') return obj as MoovlyObject;
  await new Promise((resolve) => setTimeout(resolve, 2000));
  const newObj = await clients.Objects.object.get(obj.library_object_id);
  return pollObject(newObj);
};

export const getLogo = async (file: File): Promise<MoovlyObject> => {
  const [uploadingObj] = await clients.Objects.object.create(file);
  return await pollObject(uploadingObj);
};
